<template>
  <div>
    <span v-if="delta">
      <v-icon v-if="score > 0" color="#04aa33">mdi-chevron-up</v-icon>
      <v-icon v-else-if="score < 0" color="#d20000">mdi-chevron-down</v-icon>
      <v-icon v-else>mdi-minus</v-icon>
    </span>
    <span
      v-if="!(delta && Math.abs(score) <= 0)"
      :style="{ color: textColorStyle }"
      :class="{ invalid: !isValidNumber }"
      >{{ formattedScore }}
    </span>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    color: { type: Boolean, default: false },
    customColor: { type: String, default: null },
    score: { type: [String, Number], default: null },
    delta: { type: Boolean, default: false },
    decimals: { type: [String, Number], default: 4 },
  },
  computed: {
    isValidNumber() {
      if (this.score === '?') {
        return false
      }

      if (this.score === '-') {
        return false
      }

      if (!this.score && this.score !== 0) {
        return false
      }

      return true
    },
    formattedScore() {
      if (!this.isValidNumber) {
        return '-'
      }
      // if (this.score === '?') {
      //   return '-'
      // }

      // if (this.score === '-') {
      //   return '-'
      // }

      // if (!this.score && this.score != 0) {
      //   return '-'
      // }
      const rounded = _.round(this.score, this.decimals)
      if (rounded === 0) {
        return '0.0000'
      }

      var roundedStr = '' + rounded
      if (
        Math.abs(rounded) < 1 &&
        roundedStr.length > 1 &&
        roundedStr.length < 6
      ) {
        roundedStr = _.padEnd(roundedStr, 6, '0')
      }

      if (this.delta) {
        return roundedStr || ''
      } else {
        return roundedStr || '-'
      }
    },
    textColorStyle() {
      if (this.customColor !== null) {
        return this.customColor
      }
      if (!this.color) {
        return ''
      }

      if (this.score > 0) {
        return '#04aa33'
      } else if (this.score < 0) {
        return '#d20000'
      } else {
        return ''
      }
    },
  },
}
</script>
<style scoped>
.invalid {
  color: var(--color-subtle);
}
</style>
